import {
  AppDispatch,
  getClientOrganizationListRequest,
  toggleClientOrganizationActivation,
  toggleClientOrganizationActivationClear,
  toggleClientOrganizationActivationRequest,
  updateOrganization,
  updateOrganizationClear,
  updateOrganizationRequest,
} from "@src/redux";
import { Button } from "antd";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
interface SlaCardProps {
  onCancel: () => void;
  client: any;
}

const SlaCard: React.FC<SlaCardProps> = ({ client, onCancel }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch<AppDispatch>();
  const { result: updateOrgResult, loading: updateOrgLoading } =
    useSelector(updateOrganization);
  const {
    result: toggleClientOrganizationResult,
    loading: toggleClientOrganizationLoading,
  } = useSelector(toggleClientOrganizationActivation);

  const resendAgreement = () => {
    dispatch(
      updateOrganizationRequest({
        id: client?.id || "",
        data: {
          isActivated: false,
        },
      })
    );
  };

  const activate = () => {
    dispatch(
      toggleClientOrganizationActivationRequest({
        id: client?.id || "",
      })
    );
  };

  useEffect(() => {
    if (updateOrgResult?.status === "success") {
      dispatch(updateOrganizationClear());
      toast.success(
        client?.requireSlaAcceptance
          ? t("organization_deactivated")
          : t("organization_activated")
      );
      onCancel();

      dispatch(
        getClientOrganizationListRequest({
          filter: {},
          pagination: {
            pageNumber: 1,
            pageLimit: 10,
          },
          sort: [
            {
              field: "name",
              order: "asc",
            },
          ],
        })
      );
    } else if (toggleClientOrganizationResult?.status === "success") {
      toast.success(
        client?.isActivated
          ? t("SLA deactivated successfully.")
          : t("SLA Activated Successfully.")
      );
      dispatch(toggleClientOrganizationActivationClear());
      onCancel();
      dispatch(
        getClientOrganizationListRequest({
          filter: {},
          pagination: {
            pageNumber: 1,
            pageLimit: 10,
          },
          sort: [
            {
              field: "name",
              order: "asc",
            },
          ],
        })
      );
    } else if (updateOrgResult?.error?.message) {
      toast.error(updateOrgResult?.error?.message);
      dispatch(updateOrganizationClear());
    } else if (toggleClientOrganizationResult?.error?.message) {
      toast.error(toggleClientOrganizationResult?.error?.message);
      dispatch(toggleClientOrganizationActivationClear());
    }
  }, [updateOrgResult, toggleClientOrganizationResult]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "15px",
        gap: "10px",
      }}
    >
      <Button className="cancel-button" onClick={onCancel}>
        {t("cancel")}
      </Button>
      <Button
        className="agreement-button"
        onClick={resendAgreement}
        loading={updateOrgLoading}
      >
        {t("resend_agreement")}
      </Button>
      <Button
        type="primary"
        onClick={activate}
        loading={toggleClientOrganizationLoading}
      >
        {/* <Button type="primary" onClick={activate} loading={update_org_loading}> */}
        {/* <Button type="primary" onClick={activate} loading={update_org_loading}> */}
        {client?.isActivated ? t("deactivate") : t("activate")}
      </Button>
    </div>
  );
};

export default SlaCard;
